import { AppInfoPagedGrid } from 'BrokerTsLib/src/dtos'
import { AppInfoMessage, AppInfoMessagePagedQuery } from 'BrokerTsLib/src/dtos/User'
import { Product } from 'BrokerTsLib/src/enums'
import { baseUrl, GenericQueryOptions, oneHourStaleTime } from 'BrokerTsLib/src/hooks'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import apiClient from '../Utils/apiClient'

const appInfoApiUrl = process.env.REACT_APP_APP_INFO_API
const url = `${baseUrl}/${appInfoApiUrl}`

const setReadAppInfoMessage = (data: { read: boolean; id: number }) =>
  apiClient.post(`${url}/SetReadAppInfoMessage`, data)

export const useSetReadAppInfoMessage = (product?: Product) => {
  const queryClient = useQueryClient()
  return useMutation(setReadAppInfoMessage, {
    onSuccess: () => {
      queryClient.invalidateQueries(['useGetUnreadMessages', product])
    },
  })
}

export const useGetAllAppInfoMessages = () => {
  return useMutation((data: AppInfoMessagePagedQuery) =>
    apiClient.post<AppInfoPagedGrid>(`${url}/GetAllAppInfoMessages`, data).then((res) => {
      res.data.items = res.data.items.map((item) => ({
        ...item,
        messageShow: (item.messageShow as any) === 1,
      }))
      return res
    }),
  )
}

export const useSaveAppInfoMessage = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (message: AppInfoMessage) => {
      const msg = { ...message } as any
      msg.messageShow = message.messageShow ? 1 : 0
      return apiClient.post<number>(`${url}/Save`, msg)
    },
    { onSuccess: () => queryClient.invalidateQueries('useGetAppInfoMessage') },
  )
}

export const useGetAppInfoMessage = (id: string, options?: GenericQueryOptions<AppInfoMessage>) => {
  return useQuery(
    ['useGetAppInfoMessage', id],
    () =>
      apiClient.get<AppInfoMessage>(`${url}/Get?id=${id}`).then((res) => {
        res.data.messageShow = (res.data.messageShow as any) === 1
        return res
      }),
    options,
  )
}

export const useGetGetAppInfoUnreadMessages = (
  product?: Product,
  options?: GenericQueryOptions<number>,
) => {
  return useQuery(
    ['useGetUnreadMessages', product],
    () => apiClient.get<number>(`${url}/GetUnreadMessages?product=${product}`),
    {
      staleTime: oneHourStaleTime,
      ...options,
    },
  )
}
